module.exports = __webpack_public_path__ + "img/session-thematique-5-soloVenere.9f5c653.jpg";